import produce from 'immer';
import React from 'react';
import { useSelector } from 'react-redux';
import MetadataForm from '~/components/metadata_form';
const AdvancedClauseSearch = (props) => {
    const { advancedFilters, setAdvancedFilters } = props;
    const { orgMetadata: anyOrgMetadata } = useSelector((state) => state.orgMetadataState);
    const orgMetadata = anyOrgMetadata;
    const onFormChange = (name, value) => {
        setAdvancedFilters(Object.assign(Object.assign({}, advancedFilters), { [name]: value }));
    };
    if (orgMetadata === null) {
        return (React.createElement("div", { className: 'text-center' }, "Loading..."));
    }
    const includeExpired = !!(advancedFilters === null || advancedFilters === void 0 ? void 0 : advancedFilters.includeExpired);
    const metadata = [];
    for (const [name, value] of Object.entries(advancedFilters)) {
        metadata.push({ name, value });
    }
    const modifiedOrgMetadata = produce(orgMetadata, draft => {
        const formSourceIndex = draft.findIndex(orgMetaField => orgMetaField.name === 'Form Source');
        if (formSourceIndex !== -1)
            draft[formSourceIndex].isMulti = true;
    });
    const formStatusField = orgMetadata.find(orgMetaField => orgMetaField.name === 'Form Status');
    return (React.createElement("div", { className: 'advanced-clause-search', "data-testid": 'advanced-clause-search-dialog' },
        React.createElement(MetadataForm, { orgMetadata: modifiedOrgMetadata, handleFormChange: onFormChange, metadata: metadata, fieldsToRender: [
                'Lines of Business',
                'Form Source',
                'Competitor',
            ], optionalFields: ['*'] }),
        formStatusField &&
            React.createElement("div", { className: 'clause-classification advanced-search-group' },
                React.createElement("div", { className: 'advanced-search-inputs' },
                    React.createElement("input", { type: 'checkbox', id: 'include_expired', "data-testid": 'search-include-expired-input', checked: includeExpired, onChange: () => onFormChange('includeExpired', !includeExpired), className: 'input checkbox' }),
                    React.createElement("label", { className: 'input-label', htmlFor: 'include_expired' }, "Include Expired")))));
};
export default AdvancedClauseSearch;
